import * as $ from 'jquery';
import { CreditFormPageApplication } from './CreditFormPageApplication';

$(() => {
    const creditFormPage = $('[data-credit-form-page]');
    // If we are not on companyPaying page we stop script
    if (creditFormPage.length === 0) {
        return;
    }

    let container = $(creditFormPage[0]);
    container.data('creditFormPageApp', new CreditFormPageApplication(container));
});
